import React from 'react'
import { Navbar } from 'react-bootstrap'
import Footer from '../components/Footer/Footer'

function ForgetPassword() {
  return (
    <div>
      <Navbar/>
      <Footer/>
    </div>
  )
}

export default ForgetPassword